export default __webpack_public_path__ + "static/media/662.52459b0b.gif";